import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import useStateCallback from "../../util/customHooks/useStateCallback";
import ajaxShift from "../../util/remote/ajaxShift";
import ClosingEmployeeShift from "./ClosingEmployeeShift";
const ViewActiveAttendanceSessions = () => {
  const station_id = Number(window.localStorage.getItem("FuelFy@station_id"));

  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [attendances, setAttendances] = useState([]);
  const [viewType, setViewType] = useState("table view");
  const [update, setUpdate] = useStateCallback(false);
  const fetchAttendances = async () => {
    setLoading(true);
    const data = { station_id };
    const response = await ajaxShift.list_Attendance(data); // Your API call
    if (response.status === "OK") {
      setAttendances(response.details || []);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchAttendances();
  }, [station_id]);
  const toggleView = (type) => setViewType(type);
  const handleViewDetails = (attendance) => {
    setUpdate(false, () =>
      setUpdate(
        <ClosingEmployeeShift data={attendance} func={fetchAttendances} />
      )
    );
  };
  const filteredActions = [
    {
      label: "card view",
      icon: "fa-regular fa-address-card",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("card view"),
    },
    {
      label: "table view",
      icon: "fa-solid fa-table",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("table view"),
    },
  ].filter((action) => action.label !== viewType);
  return (
    <AppContainer
      title="Active Attendance Sessions"
      previousPageTitle="Dashboard"
      actions={filteredActions}
    >
      <div className="container-fluid">
        <Toaster />
        {update}
        {loading ? (
          <div className="text-center my-5 fs-5 text-muted">
            Loading Attendance Sessions...
          </div>
        ) : attendances.length === 0 ? (
          <div className="text-center my-5 fs-5 text-muted">
            No Attendance Sessions Available
          </div>
        ) : viewType === "table view" ? (
          <div className="row">
            <div className="col-12">
              <div className="card custom-card">
                <div className="card-body">
                  <h6 className="card-title mb-1">Attendance Sessions</h6>
                  <p className="text-muted card-sub-title">
                    List of active attendance sessions
                  </p>
                  <div className="table-responsive">
                    <table className="table table-bordered text-nowrap mb-0">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Shift ID</th>
                          <th>Employee ID</th>
                          <th>Check-in Time</th>
                          <th>Check-out Time</th>
                          <th>Date</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {attendances.map((att, index) => (
                          <tr key={att.id}>
                            <td>{index + 1}</td>
                            <td>{att.shift_id}</td>
                            <td>{att.employee_id}</td>
                            <td>{att.checkin_time}</td>
                            <td>{att.checkout_time || "N/A"}</td>
                            <td>{att.date}</td>
                            <td>
                              {att.status === "1" ? "Active" : "Inactive"}
                            </td>
                            <td>
                              <button
                                className="btn btn-sm btn-info"
                                onClick={() => handleViewDetails(att)}
                              >
                                <i className="fe fe-edit-2"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="row">
            {attendances.map((att) => (
              <div className="col-md-3 col-lg-3 mb-3" key={att.id}>
                <div
                  className="card h-100"
                  style={{
                    borderRadius: "12px",
                    boxShadow: "4px 4px 12px rgba(0,0,0,0.1)",
                  }}
                >
                  <div className="card-body text-center">
                    <h6 className="mb-1">Employee: {att.employee_id}</h6>
                    <small className="d-block text-muted">
                      Station ID: {att.station_id}
                    </small>
                    <small className="d-block text-muted">
                      Shift ID: {att.shift_id}
                    </small>
                    <small className="d-block text-muted">
                      Check-in: {att.checkin_time}
                    </small>
                    <small className="d-block text-muted">
                      Check-out: {att.checkout_time || "N/A"}
                    </small>
                    <small className="d-block text-muted">
                      Date: {att.date}
                    </small>
                    <div className="mt-2">
                      <span
                        className={`badge ${
                          att.status === "1" ? "bg-success" : "bg-secondary"
                        }`}
                      >
                        {att.status === "1" ? "Active" : "Inactive"}
                      </span>
                    </div>
                    <div className="d-flex justify-content-center mt-3">
                      <button
                        className="btn btn-sm btn-outline-primary px-3"
                        onClick={() => handleViewDetails(att)}
                      >
                        <i className="fe fe-edit-2"></i> Edit
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </AppContainer>
  );
};
export default ViewActiveAttendanceSessions;
